import React, { useState } from "react";
import { contactSupport } from "../../src/GameServices/GameServices";
import swal from "sweetalert";

const useContactSupport = () => {
  const [dataFields, setDataFields] = useState({
    name: "",
    company: "",
    country: "",
    email: "",
    phone: "",
    message: "",
  });

  const send = async (e) => {
    e.preventDefault();
    const data = {
      name: dataFields.name,
      company: dataFields.company,
      country: dataFields.country,
      email: dataFields.email,
      phone: dataFields.phone,
      message: dataFields.message,
      origin: "Contact Support",
    };

    const resp = await contactSupport(data);

    if (resp.data) {
      swal("Success!", "Response Submitted Successfully!", "success");

      setDataFields({
        name: "",
        company: "",
        country: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      swal("error!", resp.response.data.message, "error");
    }
  };

  return {
    dataFields,
    setDataFields,
    send,
  };
};

export default useContactSupport;
